import {Directive} from '@angular/core';

@Directive({
  selector: `ui-bullet-chart-description, [ui-bullet-chart-description], [uiBulletChartDescription]`,
  host: {
    class: 'mat-caption ui-bullet-chart-description g-chart-description'
  }
})
export class BulletChartDescriptionDirective {}
